module.exports = __webpack_public_path__ + "img/8da1bbd66b0a7ca2803bee6b6365b0dc.png";